// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3gr2p","options":"AnswerScale_options__2qziX","selected":"AnswerScale_selected__1Xchz"};